'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeProvider = require('@spp/theme-provider');

var _PublicationTimestamp = require('./PublicationTimestamp');

var _PublicationTimestamp2 = _interopRequireDefault(_PublicationTimestamp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeProvider.themer)('@vg/publication-timestamp')(_PublicationTimestamp2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/publication-timestamp/lib/cjs/index.js
 ** module id = 735
 ** module chunks = 1
 **/